document.addEventListener('DOMContentLoaded', function () {
  const productSection = document.querySelector('.product');

  if (!productSection) return;

  /* Apparition progressive de la colonne de droite */
  const productInfo = document.querySelector('.product__info-wrapper');

  if (productInfo) {
    productInfo.classList.add('flexora-reveal');

    window.requestAnimationFrame(function () {
      productInfo.classList.add('flexora-reveal--visible');
    });
  }

  /* Amélioration de la miniature sélectionnée */
  const thumbnails = document.querySelectorAll(
    '.thumbnail-list__item button, .thumbnail-list__item .thumbnail'
  );

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      thumbnails.forEach(function (item) {
        item.classList.remove('flexora-thumbnail-active');
      });

      thumbnail.classList.add('flexora-thumbnail-active');
    });
  });

  /* Animation légère du bouton Ajouter au panier */
  const addToCartButton = document.querySelector(
    '.product-form__submit, button[name="add"]'
  );

  if (addToCartButton) {
    addToCartButton.addEventListener('mousedown', function () {
      addToCartButton.classList.add('flexora-button-click');
    });

    addToCartButton.addEventListener('mouseup', function () {
      addToCartButton.classList.remove('flexora-button-click');
    });

    addToCartButton.addEventListener('mouseleave', function () {
      addToCartButton.classList.remove('flexora-button-click');
    });
  }
});